import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { FileUploadDialogComponent } from '../components/file-upload-dialog/file-upload-dialog.component';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(public dialog: MatDialog, private http: HttpClient) {}

  async promptForUpload(teamName: string, dataset: string = null) {
    const dialogRef = this.dialog.open(FileUploadDialogComponent, {
      width: '600px',
      position: { bottom: '0px', right: '0px' },
      disableClose: true, //disable closing dialog via esc btn
      hasBackdrop: false, //modeless
      panelClass: 'no-overflow-dialog-container',
      data: { teamName, dataset }
    });

    const results = await lastValueFrom(dialogRef.afterClosed());
    return results;
  }

  async promptForUploadWithFiles(teamName: string, dataset: string = null, files: FileList, suggestedDestination: string = null) {
    // If we have a suggested destination, show centered overlay with backdrop
    // Otherwise fall back to the corner position
    const hasSmartSuggestion = !!suggestedDestination;

    const dialogRef = this.dialog.open(FileUploadDialogComponent, {
      width: hasSmartSuggestion ? '450px' : '600px',
      maxWidth: '90vw',
      position: hasSmartSuggestion ? undefined : { bottom: '0px', right: '0px' },
      disableClose: true,
      hasBackdrop: hasSmartSuggestion,
      panelClass: hasSmartSuggestion ? 'quick-upload-dialog' : 'no-overflow-dialog-container',
      data: { teamName, dataset, droppedFiles: files, suggestedDestination }
    });

    const results = await lastValueFrom(dialogRef.afterClosed());
    return results;
  }

  /**
   * Upload files directly without showing a dialog.
   * Uses the simplified raw upload endpoint that accepts relative paths.
   */
  async uploadFilesDirect(teamName: string, files: FileList, destinationFolder: string): Promise<any[]> {
    const results: any[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      // Build relative path within raw folder
      const relativePath = destinationFolder
        ? `${destinationFolder}/${file.name}`
        : file.name;

      const formData = new FormData();
      formData.append('file', file);
      formData.append('path', relativePath);

      try {
        const result = await lastValueFrom(
          this.http.post(`${ConfigService.apiUrl}/data/raw/${teamName}/upload`, formData)
        );
        results.push({ success: true, file: file.name, result });
      } catch (error) {
        results.push({ success: false, file: file.name, error });
      }
    }

    return results;
  }
}
